module.exports = __webpack_public_path__ + "static/img/icon2.6d4ca281.png";